import { CoreIcon } from '../core-icon';
import fingerprintSVG from '../../assets/icons/fingerprint.svg';
import type { IconProps } from '../core-icon';

export const FingerprintIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={fingerprintSVG} {...props} />;
};
